angular.module("bccNgApp").controller('TrialsSearchController', ["$scope", function ($scope) {

    $scope.sites = [];
    $scope.types = [];
    $scope.phases = [];
    $scope.site = "";
    $scope.type = "";
    $scope.phase = "";
    $scope.loading = true;
    $scope.resultCount = 0;
    $scope.results = [];
    $scope.pages = [];
    $scope.page = 1;
    $scope.keywords = "";
    $scope.showMobile = false;

    $scope.init = function (keywords) {
        $scope.keywords = keywords;
        getResults();
    }

    $scope.setSite = function (e, site) {
        e.preventDefault();
        $scope.site = site;
        updateQuerystring("s", site);
        getResults();
    }

    $scope.setType = function (e, type) {
        e.preventDefault();
        $scope.type = type;
        updateQuerystring("t", type);
        getResults();
    }

    $scope.setPhase = function (e, phase) {
        e.preventDefault();
        $scope.phase = phase;
        updateQuerystring("p", phase);
        getResults();
    }

    $scope.clearAll = function (e) {
        e.preventDefault();
        $scope.setSite(e, '');
        $scope.setType(e, '');
        $scope.setPhase(e, '');
    }

    $scope.changePage = function (e, page) {
        e.preventDefault();
        if (page <= $scope.pages.length && page > 0) {
            $scope.page = page;
            updateQuerystring("pg", page);
            $([document.documentElement, document.body]).animate({
                scrollTop: $(".component-clinical-trial-search").offset().top
            }, 400);
            getResults(false);
        }
    }

    $scope.toggleMobileFilters = function (e) {
        e.preventDefault();
        $scope.showMobile = !$scope.showMobile;
    }

    $scope.showMore = function(e, id) {
        e.preventDefault();
        $("#" + id).slideToggle();
        var $parent = $("#" + id).parent();
        if (!$parent.hasClass("open")) {
            $parent.addClass("open");
        }
        else {
            $parent.removeClass("open");
        }
    }

    function getResults(resetPage = true) {
        if (resetPage) {
            $scope.page = 1;
        }
        var url = buildUrl();
        $.get(url, function (data) {
            $scope.results = data.Results;
            $scope.resultCount = data.ResultCount;
            $scope.sites = data.Facets.bcc_trial_site;
            $scope.phases = data.Facets.bcc_trial_phase;
            $scope.types = data.Facets.bcc_trial_type;
            $scope.loading = false;
            var pages = Math.ceil(data.ResultCount / data.Criteria.PageSize);
            $scope.pages = [];
            for (var i = 1; i <= pages; i++) {
                $scope.pages.push(i); 
            }
            $scope.$apply();
        }).fail(function () {
            alert("Error getting events.")
        });
    }

    function buildUrl() {
        var url = "/api/sitecore/BccTrials/Api?pg=" + $scope.page;
        if ($scope.keywords.length > 0) {
            url += "&q=" + $scope.keywords;
        }
        if ($scope.site.length > 0) {
            url += "&s=" + $scope.site;
        }
        if ($scope.type.length > 0) {
            url += "&t=" + $scope.type;
        }
        if ($scope.phase.length > 0) {
            url += "&p=" + $scope.phase;
        }
        return url;
    }

    function updateQuerystring(key, value) {
        if ("URLSearchParams" in window) {
            var searchParams = new URLSearchParams(window.location.search);
            searchParams.set(key, value);
            var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + searchParams.toString();
            window.history.pushState({ path: newurl }, '', newurl);
            $("form.bcc-search-form").each(function () {
                var input = $(this).find("input[name='" + key + "']");
                if (input.length > 0) {
                    input.attr("value", value);
                } else {
                    $(this).append('<input type="hidden" name="' + key + '" value="' + value + '" />')
                }
            });
        }
    }

}]);